<template>
    <div id="bankTransferList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                  <div class="page-title"> Debt Notes Interest List</div>
                  <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backScreen" >
                          <i class="fp-back"> </i> Back
                  </button>
                   <!-- <button v-if="!addLine" type="submit" class="btn btn-primary pull-right mr-2" v-on:click.prevent="addLineItem">
                        <i class="fp-add"> </i> Add Line
                    </button> -->
                    <button type="submit" v-if="payoffEnable" class="btn btn-primary pull-right mr-2" v-on:click.prevent="undoPayoff">
                        <i class="fp-add"> </i> Undo PayOff
                    </button>
                  <button v-if="status == 'Active'" type="submit" class="btn btn-secondary pull-right mr-2" v-on:click.prevent="changeInterst" >
                          Change
                  </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content debtnote-view">

                        <section class="internal-container border-top-table-fl filters-container" >
                            <div class="content" v-if="addLine">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="DebtNoteLineForm">
                                    <div class="form-row row-cols-md-6 row-cols-1" style="width:200% !important">

                                        <div class="purchase-order-create-main table-responsive-sm">
                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th scope="col">Date</th>
                                                        <!-- <th scope="col">Amount</th>
                                                        <th scope="col">Rate</th> -->
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-if="chrows.length > 0">
                                                        <tr v-for="(crow, cindex) in chrows" :key="cindex">
                                                            <td>
                                                                <date-picker placeholder="MM/DD/YYYY" format="MM/DD/YYYY" id="date" name="date" v-model="crow.date" :config="optionsDate" ></date-picker>
                                                                <div class="field-error">{{ crow.date_error_msg }}</div>
                                                            </td>
                                                            <!-- <td>
                                                                <input type="text" ref="infoBox" class="form-control text-right" v-model="crow.amount" id="amount" placeholder="Add Amount" name="amount" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
                                                                <div class="field-error">{{ crow.amount_error_msg }}</div>
                                                            </td>
                                                            <td>
                                                                <input type="text" placeholder="Enter Rate" v-model="crow.rate" name="rate" id="rate" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                <div class="field-error">{{crow.rate_error_msg}}</div>
                                                            </td> -->
                                                            <td>&nbsp;&nbsp;&nbsp;
                                                                <a class="" href="javascript:void(0)" v-on:click.prevent="removeElement(cindex);">
                                                                    <i class="fp-remove"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-else>
                                                        <tr><td colspan="4">No records found.</td></tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                            <div class="btn-groups">
                                                <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                                    <i class="fp-add"></i> Add Line Item
                                                </button>
                                            </div>
                                            <div class="btn-groups pull-left">
                                                <button type="submit" id="updateDebtNoteBtn" class="btn btn-primary" v-on:click.prevent="updateDebtNoteLine">
                                                    <i class="fp-reload"> </i> Update
                                                </button>
                                                <button type="submit" id="CancelDebtNoteBtn" class="btn btn-tertiary" v-on:click.prevent="cancelUpdateLine">
                                                    <i class="fp-close"> </i> Cancel
                                                </button>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="form-row" v-show="!addLine">
                                <div class="col-md-6">
                                    <div class="form-row form-group">
                                        <label class="col">Note Amount:</label>
                                        <span class="col label"> {{ note_amount }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Start Date:</label>
                                        <span class="col label"> {{ start_date }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Number of Payments:</label>
                                        <span class="col label"> {{ number_of_payment }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Total Interest:</label>
                                        <span class="col label"> {{ total_interest }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Unit #:</label>
                                        <span class="col label"> {{ asset_number }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-row form-group">
                                        <label class="col"> Status: </label>
                                        <span class="col label">
                                            <button v-if="status == 'Entered'" type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="changeStatus" >
                                                Active
                                            </button>
                                            <template>{{ status }}</template>
                                        </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Reference Number: </label>
                                        <span class="col label"> {{ reference_number }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Financier: </label>
                                        <span class="col label"> {{ financier }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Interest Rate: </label>
                                        <span class="col label"> {{ rate }} </span>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <div class="data-table bg-white border-top-table-fl">

                          <section class="view-page-table bg-white data-table p-0 mt-4">
                                <vue-good-table
                                    ref="debtNoteInterestList"
                                    title="Debt Note Interest List"
                                    @on-selected-rows-change="selectionChanged"
                                    :columns="columns"
                                    :rows="rows"
                                    :key="rows.length"
                                    :totalRows="totalRecords"
                                    :pagination-options="{
                                        enabled: true,
                                        position:'top',
                                        mode: 'records',
                                        perPage: 50,
                                        perPageDropdown:[50,100],
                                        dropdownAllowAll: false,
                                    }"
                                    :search-options="{
                                        enabled: false,
                                        placeholder: 'Search Debt Note Interest rate',
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :sort-options="{
                                        enabled: true,
                                    }"
                                    >
                                    <div slot="emptystate">
                                        No Data Found.
                                    </div>
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">

                                          <div v-if="props.column.field == 'action'">
                                              <template v-if="isPostable(props.row) == true && isFirstPost(props.row) == true
                                              && props.row.intereset_posted == 'N' && props.row.principal_posted == 'N' && status == 'Active'
                                              && canAccessPost == true">
                                                  <button type="submit" class="btn btn-secondary" v-on:click.prevent="postInterst(props.row.id)" >
                                                          <i class="fp-save"> </i> Post
                                                  </button>
                                              </template>

                                          </div>
                                          <div v-else-if="props.column.field == 'principal_payment' || props.column.field ==  'interest'
                                          || props.column.field ==  'note_balance'">
                                            $ {{ amountFormat(props.formattedRow[props.column.field]) }}
                                          </div>
                                          <!--div v-else-if="props.column.field ==  'intereset_posted' || props.column.field ==  'principal_posted' ">
                                            <template v-if="props.formattedRow[props.column.field] == null">
                                              <label class="control-label" for="vehicle_id">N</label>
                                            </template>
                                            <template v-else>
                                            <label class="control-label" for="vehicle_id">Y</label>
                                            </template>
                                          </div-->
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="isPost && status == 'Active'" id="postInterstBtn" v-on:click.prevent="postInterst('')" class="btn btn-primary">Post</button>
                                        <button v-if="isDelete && status == 'Active'" id="removeInterstBtn" v-on:click.prevent="removeInterst('')" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                            </section>

                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>


        <div class="modal fade" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Schedule</h5>
                    </div>
                    <div class="modal-body">
                        <form class="addinspectionForm">
                            <div class="form-row row-cols-md-8 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="vehicle_id">Payment Date:</label>
                                    <v-select v-model="schedulePayment" name="vehicle_type"
                                    placeholder="Select Payment Date." label="text" :options="schedulePaymentArr">
                                    </v-select>
                                    <div class="field-error">{{ schedulePayment_error_msg }}</div>
                                </div>
                            </div>

                            <template v-if="schedulePayment != null & schedulePayment!= ''">

                                <template>

                                <div class="form-row">
                                    <div class="col-sm-12">
                                        <div class="journal-title">
                                            <h5> Instalment Detail </h5>
                                        </div>


                                        <div class="table-reponsive-sm mb-4">
                                            <table aria-describedby="table" id="contact_table" class="table table-sm purchase-order-item-table font-1" >
                                            <label> Old Detail </label>
                                                <tr>
                                                    <td style="border: none;" class="border-none wt-20">
                                                        <label>Principal Payment</label>
                                                    </td>

                                                    <td style="border: none;" class="border-none wt-20">
                                                        <label>Interest</label>
                                                    </td>

                                                    <td style="border: none;" class="border-none wt-20">
                                                        <label>Rate</label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style="border: none;" class="border-none wt-20">
                                                        {{ schedulePayment.principal_payment }}
                                                    </td>
                                                    <td style="border: none;" class="border-none wt-20">
                                                        {{ schedulePayment.interest }}
                                                    </td>
                                                    <td style="border: none;" class="border-none wt-20">
                                                        {{ schedulePayment.rate }}
                                                    </td>

                                                </tr>


                                                <label> New Detail </label>


                                                <tr>
                                                    <td style="border: none;" class="border-none wt-20">
                                                        <label>Principal Payment</label>
                                                    </td>

                                                    <td v-if="new_payment_date !== ''" style="border: none;" class="border-none wt-20">
                                                        <label>Payment Date</label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style="border: none;" class="border-none wt-20">
                                                        {{ schedulePayment.payable }}
                                                    </td>
                                                    <td v-if="new_payment_date !== ''" style="border: none;" class="border-none wt-20 form-group">
                                                        <div class="input-group">
                                                            <date-picker placeholder="MM/DD/YYYY" id="new_payment_date"
                                                              name="new_payment_date" v-model="new_payment_date"
                                                              :config="optionsDate">
                                                            </date-picker>
                                                            <label for="new_payment_date"
                                                              class="fp-calendar input-calender-icon">
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>



                                            </table>
                                        </div>

                                    </div>
                                </div>


                                </template>
                            </template>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                        <button :disabled="isValidChange" class="btn btn-secondary" id="myButton" v-on:click="updateSchedule()"> Update</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import EventBus from ".././event-bus";

import {commonMixins} from '../../mixins/commonMixins';
import { contractMixins } from '../../mixins/contractMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
    name: "debtNoteInterestList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Debt Notes Interest List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins,contractMixins],
    data: () => ({
      firstPayable: false,
      isValidChange: true,
      optionsDate: {
          format: 'MM/DD/YYYY',
          useCurrent: false,
          showClose: true,
      },
      new_payment_date: '',
      schedulePaymentArr: [],
      schedulePayment_error_msg: '',
      schedulePayment: '',
      isPost:false,
      isDelete:false,
      permissions:[],
      cantAccessPage:'',
      canAccessPost:'',
      loading:false,
      addLine:false,
      chrows:[],
      userColumns: [],
      columns: [
            {
                label: 'Payment Date',
                field: 'payment_date',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Payment Date', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: '#',
                field: 'instalment_number',
                type: 'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: '#', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: self.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Interest Rate',
                field: 'rate',
                type: 'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Interest Rate', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Principal Payment',
                field: 'principal_payment',
                type: 'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Principal Payment', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Interest',
                field: 'interest',
                type: 'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Interest', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Note Balance',
                field: 'note_balance',
                type: 'number',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Note Balance', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },

            {
                label: 'Interest Posted',
                field: 'intereset_posted',
                type: 'text',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Interest Posted', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
            },
            {
                label: 'Principal Posted',
                field: 'principal_posted',
                type: 'text',
                tdClass: 'text-center',
                filterOptions: {
                    enabled: true, // enable filter for this column
                    placeholder: 'Principal Posted', // placeholder for filter input
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'enter', //only trigger on enter not on keyup
                },
                sortable:true
              },
              {
                  label: 'Actions',
                  field: 'action',
                  sortable: false,
                  hidden:false,
              },
      ],
      rows: [],
      totalRecords: 0,
      note_amount: 0,
      start_date: '',
      status: '',
      reference_number: '',
      financier: '',
      number_of_payment: '',
      total_interest: '',
      asset_number: '',
      rate: '',
      statusArr: ['Entered', 'Active', 'Closed'],
      first_instalment_number: '',
      payoffEnable:false
    }),
    watch:{
        schedulePayment: function(schedulePayment) {
          var self = this;

          if(self.schedulePayment != '' && self.schedulePayment != null) {
              var idx = self.schedulePaymentArr.findIndex(obj => obj == self.schedulePayment);
              if (idx != -1) {
                idx = idx + 1;
                if(self.schedulePaymentArr.length !== idx) {
                  self.schedulePayment_error_msg = "Please remove all schedules after " + self.schedulePayment.text +" before update";
                  self.new_payment_date = '';
                  self.isValidChange = true;
                } else {
                  self.schedulePayment_error_msg = "";
                  self.new_payment_date = self.schedulePayment.text;
                  self.isValidChange = false;
                }
                // console.log("count == ", self.schedulePaymentArr.length);
                // console.log("idx == ", idx);
              }

          }






        },

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_debt_notes') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'debt_note_post_schedule') {
                    self.canAccessPost = true;
                }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();
        this.loadList();
        var path = window.location.pathname;
        var segments = path.split("/");
    },
    methods: {

      updateSchedule: function () {
        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/debtnote/schedule/change",
            type: "POST",
            data: {
              paymet_date: self.new_payment_date,
              principal_amount: self.schedulePayment.payable,
              id: self.schedulePayment.value,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                  $('#myModal').modal('hide');
                  self.$swal('','Schedule Updated successfully','success');
                  self.loadList();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-status-change');
            }
        });

      },
      changeInterst: function() {
        var self = this;
        var data = self.$refs['debtNoteInterestList'].selectedRows;
        var use = [];
        for (var i = 0; i < data.length; i++) {
            use.push(self.$refs['debtNoteInterestList'].selectedRows[i].id);
        }

        console.log("USE ==", use);
        $('#myModal').modal('show');

      },

      removeInterst: function() {
        var self = this;
        var rowCount = 0;
        var selectCount = 0;
        var data = self.$refs['debtNoteInterestList'].selectedRows;
        for (var j = 0; j < data.length; j++) {
            if (data[j].principal_posted == 'Y' || data[j].intereset_posted == 'Y'){
                self.$swal('','Please select record which are not posted','info');
                return;
            }else{
                selectCount++;
            }
        }
        for (var k = 0; k < self.rows.length; k++) {
            if (self.rows[k].principal_posted == 'N' && self.rows[k].intereset_posted == 'N'){
                rowCount++;
            }
        }

        // if (rowCount == selectCount){
        //     self.$swal('','Cannot Remove all the unposted records','info');
        //     return;
        // }
        // for (var j = 0; j < data.length; j++) {
        //     if (data[j].principal_posted == 'N' && data[j].intereset_posted == 'N'){

        //     }
        // }

        self.$swal({
              title: 'Are you sure to Delete Schedule',
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
        }).then((result) => {
            if (result.value) {

            //   var data = self.$refs['debtNoteInterestList'].selectedRows;
              var use = [];
              for (var i = 0; i < data.length; i++) {
                  use.push(self.$refs['debtNoteInterestList'].selectedRows[i].id);
              }

              console.log("USE ==", use);

              $.ajax({
                    url: process.env.ROOT_API + "/debtnote/schedule/delete",
                    type: "POST",
                    data: {
                      list: use,
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                          self.$swal('','Schedule Deleted successfully','success');
                          self.cancelAll(true);
                          self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-status-change');
                    }
              });


            } else {
              console.log("no");
            }
        });


      },

      postInterst: function (id) {
        var self = this;

        self.$swal({
              title: 'Are you sure to Post the Voucher',
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
        }).then((result) => {
            if (result.value) {
              if(id == 0 ||id == '') {
                var data = self.$refs['debtNoteInterestList'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['debtNoteInterestList'].selectedRows[i].id);
                }

                console.log("USE ==", use);
                self.postVaoucherClick(use);
              } else {
                var ids = [id];
                self.postVaoucherClick(ids);
              }

              //
            } else {
              console.log("no");
            }
        });
      },
      postVaoucherClick(ids) {
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");

        $.ajax({
            url: process.env.ROOT_API + "/debtpayment/reconciliation/pay/post",
            type: "POST",
            data: {
              id: segments[3],
              instalments: ids,
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    console.log("res =", data.content);
                    if(data.content.id > 0) {
                        self.$router.push("/debtpayment/reconciliation/view/" + data.content.id);
                    } else {
                      setTimeout(function () {
                          self.backScreen();
                      }, 1000);
                    }


                }else{

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

      },
      selectionChanged(param) {
          var self = this;
          if(param.selectedRows.length == 100) {
            EventBus.$emit('clear-selection', false);
          } else {
            // EventBus.$emit('clear-all-flags', false);
          }
          self.isPost = true;
          self.isDelete = true;
          var secquenceList = []
          param.selectedRows.forEach(element => {

            secquenceList.push(element.instalment_number);
            // console.log(self.isPost);
            if(self.isPostable(element) == true && element.intereset_posted == 'N' && element.principal_posted == 'N') {
              self.isPost = true;
            } else {
              self.isPost = false;
            }

            console.log(self.isPost);

            if(element.intereset_posted == 'N' && element.principal_posted == 'N') {
              self.isDelete = true;
            } else {
              self.isDelete = false;
            }
          });

          console.log(secquenceList);

          if(self.isPost == true) {
            for(var i = 1; i < secquenceList.length; i++) {
                if(secquenceList[i] - secquenceList[i-1] != 1) {
                      self.isPost = false;
                }
            }
          }

          if(self.isPost == true) {
            var idx = self.rows.findIndex(obj => obj.instalment_number == secquenceList[0]);
            if (idx != -1) {
              if(idx !=0) {
                var el = self.rows[idx-1];
                if(el.intereset_posted == 'N') {
                  self.isPost = false;
                }
              }

            }
          }
      },
      isPostable: function (element) {
        // var UserDate = document.getElementById("userdate").value;
        var ToDate = new Date();
        if (new Date(element.payment_date).getTime() <= ToDate.getTime()) {
             return true;
        }
        return false;
      },
      isFirstPost: function (element) {

        var self = this;

        if(element.intereset_posted == 'N' && element.principal_posted == 'N' && self.firstPayable == false) {

          self.firstPayable = true;
          self.first_instalment_number = element.instalment_number;
          return true;
        } else {
          if(self.first_instalment_number == element.instalment_number) {
            self.firstPayable = true;
            return true;
          } else {
            return false;
          }

        }


      },

      changeStatus: function() {
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");

        $.ajax({
              url: process.env.ROOT_API + "/debtnote/status_update",
              type: "POST",
              data: {
                status: 'Active',
                ids: [segments[3]]
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                    self.$swal('','Status Update successfully','success');

                    self.loadList();
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-status-change');
              }
          });
      },
      cancelAll: function (cancelAll) {
        this.$refs.debtNoteInterestList.unselectAllInternal();
      },
      backScreen(){
          var self = this;
          var url = '/debtnote/list';
          if(self.$route.query.from != undefined && self.$route.query.from == "gl" ){
            self.$router.push('/report/general-ledger');
            return;
          }else{
            self.redirectPageUrl(url);
          }
      },
      loadList() {


          var self = this;

          self.loading = true;
          var selectedRows = [];

          var path = window.location.pathname;
          var segments = path.split("/");
          self.loadFieldData(['schedule_payment_'+segments[3]]);

          var fields = {
              id: segments[3],
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              all:self.serverParams.selectedAll,
              selectedRows:selectedRows,
              action:self.action,
          };
          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/debtnote/intereset",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                      if ( self.action == "export" ) {

                          self.action = "list";
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {

                              self.excel = data.content.web;
                              var save = document.createElement("a");
                              save.href = self.excel;
                              save.download = data.content.web;
                              save.target = "_blank";

                              document.body.appendChild(save);
                              save.click();
                              document.body.removeChild(save);
                              self.$refs.debtNoteListTable.unselectAllInternal();

                          }
                          self.loadList();
                      } else{
                          self.rows = data.content.row;
                          self.note_amount = data.content.debt_note.note_amount;
                          self.start_date = data.content.debt_note.financing_start_date;
                          self.status = data.content.debt_note.status;
                          self.reference_number = data.content.debt_note.reference_number;
                          self.number_of_payment = data.content.debt_note.number_of_payment;
                          self.financier = data.content.debt_note.financier;
                          self.total_interest = data.content.debt_note.total_interest;
                          self.asset_number = data.content.debt_note.asset_number;
                          self.rate = data.content.debt_note.intereset_rate + " %";
                          self.totalRecords = data.content.totalRecords;
                          self.filteredFlag = false;
                      }
                  }else{
                      self.rows = data.content.row;
                      self.note_amount = data.content.debt_note.note_amount;
                      self.start_date = data.content.debt_note.financing_start_date;
                      self.status = data.content.debt_note.status;
                      self.reference_number = data.content.debt_note.reference_number;
                      self.number_of_payment = data.content.debt_note.number_of_payment;
                      self.financier = data.content.debt_note.financier;
                      self.total_interest = data.content.debt_note.total_interest;
                      self.asset_number = data.content.debt_note.asset_number;
                      self.rate = data.content.debt_note.intereset_rate + " %";
                      self.totalRecords = data.content.totalRecords;
                      self.filteredFlag = false;
                  }
                  if (data.content != undefined && data.content.show_button != undefined && data.content.show_button == 'true'){
                    self.payoffEnable = true;
                  }else{
                    self.payoffEnable = false;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if ( self.action == "delete" ) {
                      self.generateStatusCodeMessage(jqXHR,true,'debt-note-interest-delete')
                  }else{
                      self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-list')
                  }
              }
          });

      },
      undoPayoff:function(){
        var self = this;

        var path = window.location.pathname;
        var segments = path.split("/");
        self.$swal({
              title: 'Are you sure to Undo the Pay Off',
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCloseButton: false,
              showLoaderOnConfirm: true
        }).then((result) => {
            if (result.value) {
              self.loading = true;
              $.ajax({
              url: process.env.ROOT_API + "/undo/payoff",
              type: "POST",
              data: {
                id: [segments[3]]
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                    self.$swal('','Records added back','success');
                    self.loadList();
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-status-change');
              }
          });
            } else {
              console.log("no");
            }
        });

      },
      updateDebtNoteLine() {
        var self = this;
        var error = false;

        if (self.chrows.length != undefined && self.chrows.length > 0){
            for(var i=0;i<self.chrows.length; i++){

                self.chrows[i].date_error_msg = "";
                // self.chrows[i].amount_error_msg = "";
                // self.chrows[i].rate_error_msg = "";

                if (self.chrows[i].date == null || self.chrows[i].date == '' || !self.chrows[i].date) {
                    self.chrows[i].date_error_msg = "Date is Required.";
                    error = true;
                }

                // if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount < 0.1) {
                //     self.chrows[i].amount_error_msg = "Amount is Required.";
                //     error = true;
                // }

                // if (self.chrows[i].rate == null || self.chrows[i].rate == '' || !self.chrows[i].rate) {
                //     self.chrows[i].rate_error_msg = "Rate is Required.";
                //     error = true;
                // }

                if (self.rows.length){
                    var lastInd = self.rows.length - 1;
                    if (lastInd != undefined && new Date(self.rows[lastInd].payment_date) > new Date(self.chrows[i].date)){
                        self.chrows[i].date_error_msg = "Date should not Be less Than last schedule date.";
                        error = true;
                    }
                    if (lastInd != undefined && self.rows[lastInd].note_balance == 0 ){
                        self.$swal('','Final Note balance should not be 0','info');
                        error = true;
                    }
                }
            }
        }else{
            self.$swal('','No Line Added','error');
            error = true;
        }

        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            $("#updateDebtNoteBtn").val("Updating ...");
            $("#updateDebtNoteBtn").prop("disabled", true);
            $("#CancelDebtNoteBtn").prop("disabled", true);

            var fields = $("#DebtNoteLineForm").serializeArray();

            fields.push({
                name: "id",
                value: segments[3]
            });
            fields.push({
                name: "lines",
                value: JSON.stringify(self.chrows)
            });

            $.ajax({
                url: process.env.ROOT_API + "/debtnote-line/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    $("#updateDebtNoteBtn").val("Update");
                    $("#updateDebtNoteBtn").prop("disabled", false);
                    $("#CancelDebtNoteBtn").prop("disabled", false);

                    if (data.code == 201){
                        self.$swal('',data.message,'info');
                        return;
                    }

                    self.addLine = false;
                    self.chrows = [];

                    if (data.status == "success") {
                        self.loadList();
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    $("#updateDebtNoteBtn").val("Update");
                    $("#updateDebtNoteBtn").prop("disabled", false);
                    $("#CancelDebtNoteBtn").prop("disabled", false);
                    self.generateStatusCodeMessage(jqXHR,true,'debt-note-line-create')

                }
            });
        }else{
            self.errorValidationFocus();
        }
    },
       removeElement: function (index) {

            var self = this;

            self.chrows.splice(index, 1);

        },
        addRow: function () {

            var self = this;
            var j = self.chrows.length;
            var i = j - 1;
            var error = false;

            if ( j > 0 ) {

                self.chrows[i].date_error_msg = "";
                // self.chrows[i].amount_error_msg = "";
                // self.chrows[i].rate_error_msg = "";

                if (self.chrows[i].date == null || self.chrows[i].date == '' || !self.chrows[i].date) {
                    self.chrows[i].date_error_msg = "Date is Required.";
                    error = true;
                }

                // if (self.chrows[i].amount == null || !self.chrows[i].amount || self.chrows[i].amount < 0.1) {
                //     self.chrows[i].amount_error_msg = "Amount is Required.";
                //     error = true;
                // }

                // if (self.chrows[i].rate == null || self.chrows[i].rate == '' || !self.chrows[i].rate) {
                //     self.chrows[i].rate_error_msg = "Rate is Required.";
                //     error = true;
                // }

                if (self.rows.length){
                    var lastInd = self.rows.length - 1;
                    if (lastInd != undefined && new Date(self.rows[lastInd].payment_date) > new Date(self.chrows[i].date)){
                        self.chrows[i].date_error_msg = "Date should not Be less Than last schedule date.";
                        error = true;
                    }
                }
            }

            if ( j == 0 || error == false) {

                self.chrows.push({
                    date: '',
                    date_error_msg:'',
                    // rate: '',
                    // rate_error_msg:'',
                    // amount: '',
                    // amount_error_msg:'',
                });

            }
        },
        cancelUpdateLine:function(){
            var self = this;
            self.chrows = [];
            self.addLine = false;
        },
        addLineItem:function(){
            var self = this;

            self.addLine = true;
            self.chrows.push({
                date: '',
                date_error_msg:'',
                // rate: '',
                // rate_error_msg:'',
                // amount: '',
                // amount_error_msg:'',
            });
        },
    },
}
</script>





// WEBPACK FOOTER //
// src/components/payment/DebtNoteInteresetView.vue